import { INITIAL_STATE } from './constants';
import {
    START_LOAD_RESOURCE,
    FINISH_LOAD_RESOURCE,
    SET_RESOURCE,
} from './actionTypes';

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case START_LOAD_RESOURCE:
            return {
                ...state,

                [action.resourceId]: {
                    ...state[action.resourceId],
                    inProgress: true,
                },
            };
        case FINISH_LOAD_RESOURCE:
            return {
                ...state,

                [action.resourceId]: {
                    inProgress: false,
                    timestamp: Date.now(),
                    payload: action.payload,
                    error: action.error,
                    errorDetail: action.errorDetail,
                },
            };
        case SET_RESOURCE:
            return {
                ...state,

                [action.resourceId]: {
                    ...state[action.resourceId],
                    ...action.resource,
                },
            };
        default:
            return state;
    }
};
